import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { showFlagComponent } from 'src/redux/flags';
import { refreshCodeReviewData } from 'src/redux/pull-request/actions';
import { getCurrentPullRequestUrlPieces } from 'src/redux/pull-request/selectors';
import { urls } from 'src/redux/pull-request/urls';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export const useRetargetPullRequest = () => {
  const dispatch = useDispatch();
  const { owner, slug, id } = useSelector(getCurrentPullRequestUrlPieces);

  const retargetPullRequest = useCallback(
    async (branchName: string) => {
      if (!owner || !slug || !id || !branchName) {
        return;
      }
      const updateUrl = urls.api.v20.pullRequest(owner, slug, id);
      try {
        const updateRequest = authRequest(updateUrl, {
          method: 'PUT',
          headers: jsonHeaders,
          body: JSON.stringify({
            destination: {
              branch: {
                name: branchName,
              },
            },
          }),
        });
        const response = await fetch(updateRequest);
        if (!response.ok) {
          throw Error('Error retargeting PR');
        }
        dispatch(
          showFlagComponent('pull-request-retarget-success', {
            componentId: 'pull-request-retarget-success',
            props: { branchName },
          })
        );
        dispatch(
          refreshCodeReviewData({
            needsDiff: true,
            needsPullRequest: true,
            needsComments: true,
            needsTasks: false,
            forceNeedsMergeChecks: true,
          })
        );
      } catch {
        dispatch(showFlagComponent('pull-request-retarget-error'));
      }
    },
    [dispatch, owner, slug, id]
  );

  return {
    retargetPullRequest,
  };
};
